<ul
  class="mt-submenu-sidebar-link-wrapper mt-white sidebar-submenu submenu-wrapper list-unstyled bg-white shadow-sm position-absolute"
  *transloco="let translate"
>
  <ng-container *ngIf="integrationsMenus$ | async as integrationsMenus">
    <ng-container *ngFor="let menu of integrationsMenus">
      <ng-container [ngSwitch]="menu.name">
        <ng-container *ngSwitchCase="'software_and_downloads'">
          <li [routerLink]="menu.url" routerLinkActive="active">
            <a class="show">
              <ng-container [ngTemplateOutlet]="renderSideMenuData" [ngTemplateOutletContext]="{ menu }"></ng-container>
            </a>
          </li>
        </ng-container>

        <div *ngSwitchCase="'nav_integrations'" mt-claim-authorization [requiredClaim]="'UserSync:View'">
          <li class="position-relative parent-liwrapper">
            <a class="show">
              <ng-container [ngTemplateOutlet]="renderSideMenuData" [ngTemplateOutletContext]="{ menu }"></ng-container>
            </a>
            <ng-container *ngIf="menu.isDropdownOpen">
              <ul class="list-unstyled submenu-thirdwrapper bg-white">
              <li
                *ngFor="let subMenu of menu.submenu; let i = index"
                class="mt-submenu-title_subtitle-wrapper"
                [routerLink]="subMenu.url"
                routerLinkActive="active"
                [queryParams]="{
                  type: subMenu.name
                }"
                (click)="navigationSidebarService._integrationOption.next(subMenu.name)"
              >
                <a class="show">
                  <div class="mt-submenu-icon">
                    <mt-svg class="h12 mt-submenu-icon mt-brand-100" src="{{ subMenu.image }}">
                    </mt-svg>
                  </div>
                  <span class="mt-submenu-title"> {{ translate(subMenu.name) }}</span>
                </a>
              </li>
              </ul>
            </ng-container>
          </li>
        </div>

        <div *ngSwitchDefault mt-claim-authorization [requiredClaim]="'UserSync:View'">
          <li
            *ngIf="!(activeIntegrationCount === 0 && menu.name === 'myintegrations')"
            [routerLink]="menu.url"
            [queryParams]="
              menu.name === 'myintegrations' ||
              menu.name === 'integration_list_office365' ||
              menu.name === 'source_gsuite'
                ? {
                    type: menu.name
                  }
                : null
            "
            (click)="menu.name !== 'integration_finder' && navigationSidebarService._integrationOption.next(menu.name)"
            routerLinkActive="active"
          >
            <a class="show">
              <ng-container [ngTemplateOutlet]="renderSideMenuData" [ngTemplateOutletContext]="{ menu }"></ng-container>
            </a>
          </li>
        </div>
      </ng-container> </ng-container
  ></ng-container>

  <!-- Displays sidemenu data -->
  <ng-template let-menu="menu" #renderSideMenuData>
    <div class="mt-submenu-icon" *ngIf="menu.image">
      <mt-svg class="h12 mt-submenu-icon mt-brand-100" src="{{ menu.image }}"> </mt-svg>
    </div>
    <span class="mt-submenu-title inline-block">{{ translate(menu.name) }}</span>
    <mt-svg
      *ngIf="menu.submenu"
      class="mt-submenu-dropdown-arrow martop4 mt-submenu-icon mt-brand-100"
      src="assets/images/svgs/arrow-right.svg"
    >
    </mt-svg>
  </ng-template>
</ul>
